import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentOutline = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M850.684 317.984c0.047-0.050-273.95-274.050-273.95-274.050-27.213-27.112-64.711-43.934-106.067-43.934h-364v1024h788.002v-600c0-41.354-16.823-78.854-43.985-106.016zM620.668 172.72l101.278 101.28h-101.278v-101.28zM834.667 964.002h-668v-904.002h304c49.626 0 89.999 40.374 89.999 90v184h184c49.626 0 90.001 40.374 90.001 90v540.002z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M376.666 754.001h367.999v59.998h-367.999v-59.998z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M376.666 634.001h367.999v59.998h-367.999v-59.998z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M376.666 514.001h367.999v59.998h-367.999v-59.998z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M256.666 514.001h60v59.998h-60v-59.998z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M256.666 634.001h60v59.998h-60v-59.998z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M256.666 754.001h60v59.998h-60v-59.998z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgDocumentOutline);
export default ForwardRef;
